/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_EmptyInputs */

const en_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity data yet. Start applying to see your trends.`)
};

const de_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Aktivitätsdaten. Bewirb dich, um deine Trends zu sehen.`)
};

const fr_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée d'activité pour le moment. Commence à postuler pour voir tes tendances.`)
};

const es_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos de actividad. Empiece a postularse para ver sus tendencias.`)
};

const it_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato di attività ancora. Inizia a candidarti per vedere le tue tendenze.`)
};

const nl_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen activiteitsgegevens. Begin met solliciteren om je trends te zien.`)
};

const pl_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych o aktywności. Zacznij aplikować, aby zobaczyć swoje trendy.`)
};

const fi_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä toimintatietoja. Aloita hakeminen nähdäksesi trendit.`)
};

const da_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aktivitetsdata endnu. Begynd at ansøge for at se dine tendenser.`)
};

const sv_analytics_activity_empty = /** @type {(inputs: Analytics_Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aktivitetsdata ännu. Börja ansöka för att se dina trender.`)
};

/**
* | output |
* | --- |
* | "No activity data yet. Start applying to see your trends." |
*
* @param {Analytics_Activity_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_empty = /** @type {((inputs?: Analytics_Activity_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_EmptyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_empty(inputs)
	if (locale === "fr") return fr_analytics_activity_empty(inputs)
	if (locale === "es") return es_analytics_activity_empty(inputs)
	if (locale === "it") return it_analytics_activity_empty(inputs)
	if (locale === "nl") return nl_analytics_activity_empty(inputs)
	if (locale === "pl") return pl_analytics_activity_empty(inputs)
	if (locale === "fi") return fi_analytics_activity_empty(inputs)
	if (locale === "da") return da_analytics_activity_empty(inputs)
	if (locale === "sv") return sv_analytics_activity_empty(inputs)
	return en_analytics_activity_empty(inputs)
});